import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const FranchiseEntityProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `FranchiseEntity/${props.franchiseEntityId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `FranchiseEntity/Franchise/${props.franchiseId}`, method: 'POST', payload: props, multipart: true, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `FranchiseEntity/Franchise/${props.franchiseId}`, method: 'PUT', payload: props, multipart: true, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `FranchiseEntity/Franchise/${props.franchiseId}`, method: 'GET', secure: true });
    }, [execute]);  

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `FranchiseEntity/${props.franchiseEntityId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const value = { selectRecord, listRecords, newRecord, deleteRecord, updateRecord, createRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useFranchiseEntityStore = () => React.useContext(Context);
